export const SIGNIN = "SIGNIN";
export const GET_CURRENT_USER = "GET_CURRENT_USER";
export const SIGNIN_PL = "SIGNIN_PL";
